import { render, staticRenderFns } from "./consumableBorrowOper.vue?vue&type=template&id=2b650335&scoped=true"
import script from "./consumableBorrowOper.vue?vue&type=script&lang=js"
export * from "./consumableBorrowOper.vue?vue&type=script&lang=js"
import style0 from "./consumableBorrowOper.vue?vue&type=style&index=0&id=2b650335&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b650335",
  null
  
)

export default component.exports